<template>
  <ElConfigProvider :locale="localeMap[localeVal]">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <DialogOfUi ref="DialogOfUiRef" />
  </ElConfigProvider>
</template>

<script setup>
import { DialogOfUi } from '@/components/base'
import { setDialogOfUiRef } from '@/helper'
import useTurboLink from '@/hooks/useTurboLink'
import { useUserStore } from '@/stores'
import { ElConfigProvider } from 'element-plus'
import en from 'element-plus/dist/locale/en.mjs'
import es from 'element-plus/dist/locale/es.mjs'
import pl from 'element-plus/dist/locale/pl.mjs'
import cn from 'element-plus/dist/locale/zh-cn.mjs'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
const { initTurboLink, loginTurboLink, logoutTurboLink } = useTurboLink()
initTurboLink({})

// 注册全局ui弹框
const DialogOfUiRef = ref(null)
const $route = useRoute()
const $router = useRouter()

// end
const userStore = useUserStore()
onMounted(() => {
  setDialogOfUiRef(DialogOfUiRef.value)
})
const localeMap = {
  cn,
  en,
  pl,
  es,
}
const localeVal = computed(() => userStore.language)

userStore.getRate(undefined, true)
// 监听系统主题
if (userStore.isSystemTheme) {
  const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  userStore.setThemeMode(isDark ? 'dark' : 'light', userStore.isSystemTheme)
} else {
  userStore.setThemeMode(userStore.themeMode, userStore.isSystemTheme)
}

const getQueryString = (url, name) => {
  const index = url.indexOf('?')
  if (index !== -1) {
    const params = url.slice(index + 1)
    const searchParams = new URLSearchParams(params)
    return searchParams.get(name)
  }
  return null
}
let setRedirectUrl = () => {
  if (document.referrer.includes('google.com') && $route.query.code) {
    $router.replace({ query: { ...$route.query, code: undefined } })
    return
  }
  if ($route.query.code && !$route.fullPath.includes('/doc')) {
    localStorage.setItem('redirectUrl', window.location.href)
    setRedirectUrl = Function.prototype
  } else if ($route.query.source && !$route.query.u) {
    localStorage.setItem('registerSource', $route.query.source)
    setRedirectUrl = Function.prototype
  } else {
    if (getQueryString($route.query.redirectUrl || $route.fullPath, 'u')) {
      localStorage.setItem('redirectUrl', $route.query.redirectUrl || $route.fullPath)
      setRedirectUrl = Function.prototype
    }
  }
}

watch(
  () => $route.query,
  () => {
    if ($route.query.utm_source) {
      userStore.setChannel($route.query.utm_source)
    }
  },
)
watch(
  () => $route.path,
  () => {
    setRedirectUrl()
  },
  { immediate: true },
)
watch(
  () => userStore.isLogin,
  () => {
    if (userStore.isLogin) {
      loginTurboLink()
    } else {
      logoutTurboLink()
    }
  },
)
</script>

<style lang="scss">
@import url('./styles/common.scss');
</style>
